var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "full-width" },
        [
          _vm.selectedProject
            ? _c("project-details", { attrs: { project: _vm.selectedProject } })
            : _vm._e()
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          staticClass: "project__tabs no-border",
          attrs: { color: "white", "underline-color": "primary" }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "time-tracking",
              default: "",
              label: _vm.$t("time_tracking"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "invoices",
              label: _vm.$tc("invoice", 2),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "quotes",
              label: _vm.$tc("quote", 2),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "expenses",
              label: _vm.$tc("expense", 2),
              color: "black"
            },
            slot: "title"
          }),
          _c("time-entries", { attrs: { project: _vm.selectedProject } }),
          _c("invoices", { attrs: { project: _vm.selectedProject } }),
          _c("quotes", { attrs: { project: _vm.selectedProject } }),
          _c("expenses", { attrs: { project: _vm.selectedProject } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }